module.exports = __webpack_public_path__ + "static/media/4. Prisma3, Óleo y resina sobre lámina de acrilico, 30 x 30 x 6 cm, 2016 copy.48d737df.png";